import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import MapSearchBox from '../../../../common/MapSearchBox';
import Map from './Map';
import ParcelTable from './ParcelTable';
import { setLocation } from 'reducers/createListingReducer';

const SelectLandParcelsForm = ({ errors, setError, clearErrors }) => {
  const dispatch = useDispatch();

  const handleLocationSelected = location => {
    dispatch(setLocation(location));
  };

  return (
    <>
      <Row className="g-3 mb-3 h-95">
        <Col lg={8}>
          <MapSearchBox onSelect={handleLocationSelected} />
          <Map />
        </Col>
        <Col lg={4}>
          <ParcelTable
            errors={errors}
            setError={setError}
            clearErrors={clearErrors}
          />
        </Col>
      </Row>
    </>
  );
};

SelectLandParcelsForm.propTypes = {
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired
};

export default SelectLandParcelsForm;
